// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2c8J4","avatar":"style_avatar__15hAy","avatarDark":"style_avatarDark__3F7hp"};